import ImgWithTitle from '../../component/workspaceContainer/ImgWithTitle';
import { LoginBackButton } from '../../component/buttonComponent/ButtonComponent';
import '../forgotPassword/ForgotPassword.css';
import React from 'react';
import { useNavigate } from 'react-router-dom';

const InvalidPasswordLink = () => {
    const navigate = useNavigate();
    const btnBack = (e) => {
        e.preventDefault();
        navigate('/login', { replace: true });
    };

    return (
        <div className="forgot-password-container-main">
            <div className="forgot-password-container">
                <div className='img-with-title-container'>
                    <ImgWithTitle titleText="Sign Up Password Link" subText="Your request to sign up has expired, the link has already been used, or the link does not exist." icon="Invalid" />
                </div>
                <LoginBackButton label="Back to log in" btnClickBack={btnBack} backgroundColor="#FFFFFF" />
            </div>
        </div>
    );
};

export default InvalidPasswordLink;